<template minapp='mpx' xlang='wxml'>
  <view wx:if="{{isShow || isRequired}}" wx:class="{{isNameClass}}" class="es-content__name-cell">
    <view class="es-content__name">
      <view class="es-content__name-box">
        <text class="es-content__required-text" wx:if="{{isRequired && isRequiredShow}}">*</text>
        <view>{{label}}</view>
      </view>
      <view class="es-content__foreigner">{{sub_label}}</view>
    </view>
    <view wx:if="{{ !isDisable }}" class="es-content__name-text">
      <view class="es-content__name-field">
        <slot name="input"></slot>
      </view>
      <view class="es-content__name-text-tips">{{ nameTips }}</view>
    </view>
    <view wx:else class="es-content__name-text-disable">{{ innerValue }}</view>
    <view class="es-content__name-text-border" wx:class="{{isBorderClass}}"></view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { watch } from "@mpxjs/core";
  import store from '@/store'
  createComponent({
    classes: [],
    data: {
      // innerValue:''
    },
    props: {
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
      changeEvent:String,
      innerValue:'',
      isRequired: {
        type: Boolean,
        value: false
      },
      nameTips: {
        type: String,
        value: ''
      },
      label: {
        type: String,
        value: ''
      },
      sub_label: {
        type: String,
        value: ''
      },
      isDisable: {
        type: Boolean,
        value: false
      },
    },
    computed: {
      isBorderClass() {
        return this.nameTips?'es-content__red-border':''
      },
      isNameClass() {
        let tempClass = []
        if(this.isDisable){
          tempClass.push('es-content__disable')
        }
        if(!!this.nameTips){
          tempClass.push('es-content__no-padding')
        }
        return tempClass
      },
    },
    // watch:{
    //   innerValue(newValue) {
    //     store.dispatch(this.changeEvent, newValue)
    //   },
    // },
    methods: {},

    mounted() {}
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('name')  
      display flex
      flex-direction column
      justify-content center
      width 80px
      height 34px
      font-family PingFangSC-Regular
      font-size 14px
      letter-spacing 0
      margin-right 32px
      color #333333
    +e('name-box')
      display flex
    +e('required-text')
      color #F93822
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 76px
        right 0
    +e('foreigner')
      font-size 12px
      line-height 1
      color #999999
      transform scale(0.83)
      margin-left -4px
    +e('name-cell')
      position relative
      display flex
      min-height 34px
      color #333333
      padding 10px 0
    +e('name-field')
      display flex
      align-items center
      height 34px
    +e('name-text-border')
      position absolute
      bottom 0
      right 0
      height 1px
      width calc(100% - 90px)
      background: rgba(240,242,247,1);
      transform: scaleY(0.5);
    +e('red-border')
      background: rgba(221,8,11,0.5)
    +e('disable')
      color #bbbbbb !important
      background-color #ffffff
      /deep/ .es-field__body
        color #bbbbbb !important
        background-color #ffffff !important
        opacity 1 !important
    +e('no-padding')
      padding-bottom 0px
      margin-bottom 10px
    +e('name-text')
      width calc(100% - 80px)
      position relative
      display flex
      flex-direction column
      font-family PingFangSC-Regular
      font-size 14px
      color #333333
    +e('name-text-tips')
      // position absolute
      top 18px
      color #DD080B
      font-size 11px
      display flex
    +e('name-text-disable')
      line-height 34px
      font-size 14px
      overflow hidden
    +e('input')
      width calc(100% - 6px)
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
    }
  }
</script>

